oyc.FormStateTracking = {
  dependencies: ['FormCache'],
  selectors: {
    container: '.oyc-fst'
  },
  container: {},
  history: {},
  /**
   * @var {HTMLFormElement}
   */
  defaultForm: null,
  scrolledAlready: false,
  init: function () {
    this.container = $(this.selectors.container);
    if (0 < this.container.length) {
      let forms = {};
      this.container.each(function (i, el) {
        if (forms.hasOwnProperty(el.name) === false) {
          this.loadByHistoryState(el);
          forms[el.name] = true;
        }
      }.bind(this));
      this.defaultForm = this.container.get(0);
      this.addEvents();
    }
  },
  addEvents: function () {
    if (typeof oyc.Pager !== 'undefined') {
      let pagerListContainer = $(oyc.Pager.selectors.container);
      $(oyc.Pager.selectors.loadButton).on('click', this.updateLastPageAppended.bind(this))
      pagerListContainer.on('click', oyc.Pager.selectors.items, this.updateScrollPosition.bind(this))
      pagerListContainer.on('oyc-pager-append-items', this.scrollToHistoryPosition.bind(this));
    }
    let jobButton = $('.button.jobs');
    jobButton.on('click', function (ev) {
      if (document.referrer === this.href && this.href.match(/stellenanzeige\//)) {
        ev.preventDefault();
        history.back();
      }
    });
  },
  isTracked: function (form) {
    return this.container.filter(form).length !== 0;
  },
  /**
   *
   * @param {HTMLFormElement} form
   */
  loadByHistoryState: function (form) {
    form = form || this.defaultForm
    if (form.name.length === 0 || typeof form.name === 'undefined') {
      throw new TypeError('given form has no name');
    }
    if (history.state !== null && history.state.hasOwnProperty(form.name)) {
      this.history[form.name] = history.state[form.name];
    } else {
      this.history[form.name] = {};
    }

    if (this.history[form.name].hasOwnProperty('scrollTop')) {
      let listTop = $(oyc.Pager.selectors.list).position().top
      $(window).scrollTop(listTop);
      history.scrollRestoration = "manual";
    }
    console.log('history.state for form "' + form.name + '" loaded:', this.history[form.name]);
  },
  /**
   *
   * @param {string} property if given no value is set the property name is suspected to be an input fields name or part of a field name if the form has data attribute field-name-prefix
   * @param {*} value
   * @param {HTMLFormElement} form optional
   */
  updateValue: function (property, value, form) {
    form = form || this.defaultForm;
    if (!this.isTracked(form)) {
      return;
    }
    let jForm = $(form);
    if (typeof property !== 'undefined') {
      if (typeof value !== 'undefined') {
        this.history[form.name][property] = value;
      } else {
        let inputFieldSelector = '[name*="' + (jForm.data('field-name-prefix') || '') + '\[' + property + '\]"]';
        let field = jForm.find(inputFieldSelector)
        if (0 < field.length) {
          let fieldName = this.purFieldName(field.attr('name'));
          value = field.val();
          this.history[form.name][fieldName] = value;
        } else {
          delete this.history[form.name][property];
        }
      }
      console.log('update value for form state tracking "' + form.name + ':' + property + '":', value);
    } else {
      let formData = new FormData(form);
      for ([fieldName, value] of formData.entries()) {
        // filter out typo3 hidden fields
        if (fieldName.match(/(__referer|__trustedProperties)/)) {
          continue;
        }
        this.history[form.name][this.purFieldName(fieldName)] = value;
      }
    }
    history.replaceState(this.history, document.title);
  },
  /**
   *
   * @param property
   * @param {HTMLFormElement} form
   */
  deleteProperty: function (property, form) {
    form = form || this.defaultForm;
    if (!this.isTracked(form)) {
      return;
    }
    if (this.history[form.name].hasOwnProperty(property)) {
      delete this.history[form.name][property];
    }
    history.replaceState(this.history, document.title);
  },
  /**
   * remove all state data completely
   * @param {HTMLFormElement} form
   */
  deleteFormState: function (form) {
    if (!this.isTracked(form)) {
      return;
    }
    this.history[form.name] = {};
    history.replaceState(this.history, document.title);
  },
  /**
   *
   * @param {string} property
   * @returns {*}
   * @param {HTMLFormElement} form
   */
  getValue: function (property, form) {
    form = form || this.defaultForm;
    if (!form) {
      return;
    }
    if (typeof form.name === 'undefined' || form.name.length === 0) {
      throw new TypeError('given form has no name');
    }
    if (typeof property === 'undefined') {
      return this.history[form.name];
    }
    if (typeof this.history[form.name] === 'undefined') {
      return null;
    }
    return this.history[form.name][property];
  },
  purFieldName: function (rawName) {
    return rawName.replace(/(.*\[|].*)/g, '');
  },
  updateLastPageAppended: function (ev) {
    let lastPageAppended = parseInt(this.getValue('lastPageAppended') || 0);
    this.updateValue('lastPageAppended', lastPageAppended + 1)
  },
  updateScrollPosition: function (ev) {
    this.updateValue('scrollTop', window.scrollY);
    this.updateValue('lastPageAppended', Math.ceil(oyc.Pager.container.find(oyc.Pager.selectors.items + ':visible').length / parseInt(oyc.Pager.container.data('limit'))) - 1);
  },
  /**
   *
   * @param {HTMLFormElement|jQuery.Event} form
   */
  scrollToHistoryPosition: function (form) {
    if (this.scrolledAlready) {
      return;
    }
    this.scrolledAlready = true;
    form = (form.type ? undefined : form) || this.defaultForm
    if (typeof form.name === 'undefined' || form.name.length === 0) {
      throw new TypeError('given form has no name');
    }
    let scrollTop = this.getValue('scrollTop', form),
      listTop = $(oyc.Pager.selectors.container).position().top;
    if (typeof scrollTop !== 'undefined' && 0 < scrollTop) {
      window.setTimeout(oyc.Loader.hide.bind(oyc.Loader), 600, '#content', true);
      window.scrollTo(0, scrollTop - listTop);
      this.updateValue('scrollTop', listTop, form);
    }
  }
}

history.scrollRestoration = "auto";
